import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import { useAuthContext } from 'App/Auth'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import TwoRowErrorPage from 'shared/ErrorPages/TwoRowErrorPage'
import useStyles from 'shared/hooks/useStyle'

import styles from './TwoRowErrorPage.style'

const propTypes = { message: PropTypes.string.isRequired }

const ErrorViewWithLogout = ({ message }) => {
    const { t } = useTranslation()
    const classes = useStyles(styles)
    const { logout } = useAuthContext()

    const handleLogoutClick = useCallback(() => {
        logout()
    }, [logout])

    return (
        <TwoRowErrorPage
            message={message}
            iconPath="skycenter/crash_robot.svg"
            iconAlt="logo"
        >
            <Button
                css={classes.button}
                onClick={handleLogoutClick}
            >
                {t('LOGOUT')}
            </Button>
        </TwoRowErrorPage>
    )
}

ErrorViewWithLogout.propTypes = propTypes

export default ErrorViewWithLogout
